<template>
	<div
		class="info__card border"
		:class="[`bg-[${style[type].bg}] border-[${style[type].border}]`]"
	>
		<div class="info__card__content">
			<div class="flex flex-col">
				<div class="flex items-center gap-2">
					<Icon
						:icon="style[type].icon"
						:color="style[type].border"
						class="min-w-5"
					/>
					<p class="font-bold text-[#272728] text-base !margin-0">
						{{ description }}
					</p>
				</div>
				<p
					v-if="action"
					class="m-0 text-end cursor-pointer text-sm"
					@click="$emit('action')"
				>
					{{ action }}
				</p>
			</div>
			<div
				v-if="details.length"
				ref="optionsContainer"
				class="info__card__details"
				@click="toggleDetails = !toggleDetails"
			>
				<p class="!margin-0 text-xs uppercase font-bold text-[#464947]">
					{{ $t(dynamicText) }}
				</p>
				<!-- <i class="fas fa-angle-right"></i> -->
			</div>
		</div>
		<div
			v-show="toggleDetails"
			class="info__card__details__content border-l border-b border-r"
			:class="[`bg-[${style[type].bg}] border-[${style[type].border}]`]"
		>
			<div
				v-for="(detail, index) in details"
				:key="detail + index"
				class="cursor-pointer"
			>
				<p class="text-sm p-1 w-[94%]">
					{{ detail }}
				</p>
				<Icon
					icon="fa6-solid:angle-right"
					height="16px"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { Icon } from '@iconify/vue2'
import { computed, ref } from 'vue'
import { onClickOutside } from '@vueuse/core'

const optionsContainer = ref(null)

const dynamicText = computed(() => {
	return toggleDetails.value ? 'hideDetails' : 'seeDetails'
})

onClickOutside(optionsContainer, () => {
	toggleDetails.value = false
})

defineProps({
	type: {
		type: String,
		default: 'success',
		validator(value) {
			return ['info', 'error', 'success', 'warning'].includes(value)
		},
	},
	action: {
		type: String,
	},
	description: {
		type: String,
	},
	title: {
		type: String,
	},
	details: {
		type: Array,
		default: () => [],
	},
})

const style = computed(() => {
	return {
		info: { icon: 'akar-icons:info-fill', bg: '#C5CBF1', border: '#6745ED' },
		warning: { icon: 'fluent:warning-24-filled', bg: '#FFE986', border: '#9B5400' },
		error: { icon: 'icon-park-solid:caution', bg: '#FFA9A9', border: '#C60020' },
		success: { icon: 'ic:round-check', bg: '#92E583', border: '#138600' },
	}
})

const toggleDetails = ref(false)
</script>

<style scoped>
.info__card {
	display: flex;
	width: fit-content;
	max-width: 20%;
	border-radius: 5px;
	position: relative;
}

.info__card p {
	margin: 0;
}

.info__card__main__content {
	display: flex;
	gap: 1rem;
}

.info__card__content {
	display: flex;
	flex-direction: column;
	padding: 0.7rem;
	width: 100%;
}

.info__card__indicador {
	background-color: #edeeef;
	border-radius: 5px;
	font-weight: bold;
}

.info__card__details {
	display: flex;
	width: 100%;
	justify-content: end;
	cursor: pointer;
	gap: 0.5rem;
	position: relative;
}

.info__card__details__content {
	position: absolute;
	top: 3.5rem;
	z-index: 2;
	width: 100%;
	border-radius: 0 0 5px 5px;
	max-height: 50vh;
	overflow: auto;
}

.info__card__details__content div {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	padding: 0.5rem;
}

.info__card__details i {
	margin: auto 0;
	height: fit-content;
	font-size: 0.8rem;
	color: var(--color-gray);
}
</style>
